import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import {Page401Component} from './components/page-error/page401/page401.component';
import {Page404Component} from './components/page-error/page404/page404.component';
import {PageLoginComponent} from "./components/page/page-login/page-login.component";
import {PageLogoutComponent} from './components/page/page-logout/page-logout.component';
import {PageDashboardComponent} from './components/page/page-dashboard/page-dashboard.component';
import {GuardComponent} from "./components/core/security/guard/guard.component";

const routes: Routes = [
  { path: "", pathMatch: "full", redirectTo: "login" },
  { path: "login", component: PageLoginComponent },
  { path: "logout", component: PageLogoutComponent },

  //PAGE-LOGIN
  { path: `dashboard`, component: PageDashboardComponent, canActivate: [GuardComponent] },

  //PAGE-ERROR
  { path: "401", component: Page401Component, canActivate: [GuardComponent] },
  { path: "404", component: Page404Component, canActivate: [GuardComponent] },

  { path: "**", redirectTo: "/404" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {
  exports: [RouterModule];
}
